import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import HomeHero from "./sections/YangiKiaAvtomobillariniBizBilanTanlang";
import HomeValueStrip from "./sections/ValuePropositionStrip";
import HomeDestinations from "./sections/TrendingDestinations";
import HomeCityDiscovery from "./sections/EliteCourseSelection";
import HomeProductTools from "./sections/CourseFinder";
import HomeGolfPassport from "./sections/Golfpassportmembership";
import HomePartnerCourses from "./sections/BespokeElegance";
import HomeCommunityCTA from "./sections/NewsletterSignup";
export default function HomePage() {
  return <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main>
        <HomeHero />
        <HomeValueStrip />
        <HomeDestinations />
        <HomeCityDiscovery />
        <HomeProductTools />
        <HomeGolfPassport />
        <HomePartnerCourses />
        <HomeCommunityCTA />
      </main>
      <Footer />
    </div>;
}